// Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import { chainIdToChainConfigurationValues, prodAssetChains } from './DeploymentConfigsDefaults'
import { StageConfiguration } from './DeploymentConfigTypes'
import { ChainConfiguration } from './DeploymentConfigTypes'
import { ChainId } from './Enums'

const cognitoRegion = 'us-east-1'
const cognitoOTUserPoolId = 'us-east-1_DsQFQxybT' // IN Production these are 2 different pools
const cognitoCanaryUserPoolId = 'us-east-1_nL1ysOltK'
//const cognitoLytUserPoolId = 'us-east-'

const PLUME_MAINNET_URL = 'https://rpc.plume.org'

export const MAINNET_USDC_ADDR = '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48'
export const BASE_USDC_ADDR = '0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913'

export const PROD_DEFI_VAULT_ADDR_AAVE = '0x87870bca3f3fd6335c3f4ce8392d69350b4fa4e2'
export const PROD_DEFI_VAULT_ADDR_AAVE_CONTRACT = '0x98c23e9d8f34fefb1b7bd6a91b7ff122f4e16f5c'
export const PROD_DEFI_VAULT_ADDR_MORPHO = '0xdd0f28e19C1780eb6396170735D45153D261490d'

export const PROD_DEFI_VAULT_ADDR_MORPHO_BASE = '0xeE8F4eC5672F09119b96Ab6fB59C27E1b7e44b61'
export const PROD_CALIBRATION_WALLET_ADDR = '0x29f82e22f58e15005187a890749190930661CDEd'
export const PROD_DEFI_TRANSFER_WALLET_ADDR = '0x3736dECE46B3D86bf9e86b3E318741F7Bb6569E1'
export const PROD_FEE_VAULT_ADDR = '0x6643d74DB59411215faA16Cea48c9fb94DBD89C7'

export const PROD_DEFI_VAULT_ADDR_WILDCAT = '0xC9499006a149C553d18171747ED19Aa7C6Dd19E2'

const PROD_MAINNET_FRONTEND_URL = 'https://eth-mainnet.g.alchemy.com/v2/q9zjx0r2FcVd2jickusbV'
const PROD_MAINNET_BACKEND_URL = 'https://eth-mainnet.g.alchemy.com/v2/QJqYiOEGbhFQtwKjJUs03'
const PROD_AVALANCHE_FRONTEND_URL = 'https://avax-mainnet.g.alchemy.com/v2/p5dgOkAqxryvxryB4To24'
const PROD_AVALANCHE_BACKEND_URL = 'https://avax-mainnet.g.alchemy.com/v2/YZGQb5WG7Ax8YmC51A7vW'
const PROD_PLUME_MAINNET_FRONTEND_URL = PLUME_MAINNET_URL
const PROD_PLUME_MAINNET_BACKEND_URL = PLUME_MAINNET_URL

export const PROD_BASE_DEFAULT_URL = 'https://base-mainnet.g.alchemy.com/v2/xFwCGABaUmPxRp17S22jJ'

// WebSocket URLs
const PROD_MAINNET_FRONTEND_WS_URL = 'wss://eth-mainnet.g.alchemy.com/v2/q9zjx0r2FcVd2jickusbV'
const PROD_AVALANCHE_FRONTEND_WS_URL = 'wss://avax-mainnet.g.alchemy.com/v2/p5dgOkAqxryvxryB4To24'
const PROD_PLUME_MAINNET_FRONTEND_WS_URL = 'wss://rpc.plume.org'

const LYT_PROD_FB_SERVICE_CONFIGURATION_ADDR = '0x3e506bE019BA687aAB2d921664f46846B0626d47'

// Protocol address
const PROD_PLUME_MAINNET_SERVICE_CONFIGURATION_ADDR = '0x785B01F10496Ec28AAcEc6fb19Aec8A191199a18'
export const AVALANCHE_SERVICE_CONFIGURATION_ADDR = '0xa3bE07c2734ed1CE269Cf026Cbe8D09d146014e1'
const MAINNET_SERVICE_CONFIGURATION_ADDR = '0xec4F65e0A0268ff38ECEc711AD5159b96dAbaB98'

export const PROD_MORPHO_MAINNET_OT_POOL_ADDR = '0x9bb81E6b6a9ea5cc99d46fdde0ebbF19D303872f'

export const PROD_AAVE_OT_POOL_ADDR = '0x4a8094F20906a453a4A74769aa74c4012B0d5Df6'
export const PROD_MORPHO_BASE_OT_POOL_ADDR = '0xeE8F4eC5672F09119b96Ab6fB59C27E1b7e44b61'
export const PROD_WILDCAT_OT_POOL_ADDR = '0x4c8eaBA17c3b30295f442A6415d495e8410a5693'
// REST_API_KEYS

const PROD_REST_API_KEY = 'bljIxYzvER2ky16J5mY3p64uWn1qdkCQ6zfpCBX4'
const PROD_CANARY_REST_API_KEY = '8WwMT4vgPE63JmRhEAI7m4w93z48sQTJ9jdU3oSq'

const CHAIN_CONFIG_PROD_PLUME: ChainConfiguration = {
  ...chainIdToChainConfigurationValues(ChainId.PLUME_MAINNET),
  chainConfigurationName: 'Plume',
  serviceConfigurationAddr: PROD_PLUME_MAINNET_SERVICE_CONFIGURATION_ADDR,
  frontendProviderUrl: PROD_PLUME_MAINNET_FRONTEND_URL,
  frontendWebSocketProviderUrl: PROD_PLUME_MAINNET_FRONTEND_WS_URL,
  backendProviderUrl: PROD_PLUME_MAINNET_BACKEND_URL,
}

export const CHAIN_CONFIG_PROD_MAINNET: ChainConfiguration = {
  ...chainIdToChainConfigurationValues(ChainId.MAINNET),
  chainConfigurationName: 'Ethereum',
  serviceConfigurationAddr: MAINNET_SERVICE_CONFIGURATION_ADDR,
  frontendProviderUrl: PROD_MAINNET_FRONTEND_URL,
  frontendWebSocketProviderUrl: PROD_MAINNET_FRONTEND_WS_URL,
  backendProviderUrl: PROD_MAINNET_BACKEND_URL,
}

const CHAIN_CONFIG_PROD_AVALANCHE: ChainConfiguration = {
  ...chainIdToChainConfigurationValues(ChainId.AVALANCHE),
  chainConfigurationName: 'Avalanche',
  serviceConfigurationAddr: AVALANCHE_SERVICE_CONFIGURATION_ADDR,
  frontendProviderUrl: PROD_AVALANCHE_FRONTEND_URL,
  frontendWebSocketProviderUrl: PROD_AVALANCHE_FRONTEND_WS_URL,
  backendProviderUrl: PROD_AVALANCHE_BACKEND_URL,
  hiddenInvestVaultAddresses: ['0x37873F86EE397F88c09b210DDe555eBE3675e1A2'],
}
const CHAIN_CONFIG_LYT_PROD_FB: ChainConfiguration = {
  ...chainIdToChainConfigurationValues(ChainId.AVALANCHE),
  chainConfigurationName: 'LytProdAvalanche',
  serviceConfigurationAddr: LYT_PROD_FB_SERVICE_CONFIGURATION_ADDR,
  frontendProviderUrl: PROD_AVALANCHE_FRONTEND_URL,
  frontendWebSocketProviderUrl: PROD_AVALANCHE_FRONTEND_WS_URL,
  backendProviderUrl: PROD_AVALANCHE_BACKEND_URL,
}
export const PROD_STAGE_CONFIG: StageConfiguration = {
  stageName: 'prod', // from serverless.yml
  domain: 'app.open-trade.io',
  websocketUrl: 'wss://ws.open-trade.io',
  serverApiBaseUrl: 'https://api.open-trade.io',
  graphqlUrl: 'https://gql.open-trade.io',
  restAPIKey: PROD_REST_API_KEY,
  supportedChains: prodAssetChains,
  chainConfigurations: [CHAIN_CONFIG_PROD_MAINNET, CHAIN_CONFIG_PROD_AVALANCHE, CHAIN_CONFIG_PROD_PLUME],
  userConnections: [],
  cognitoConfig: {
    clientId: '6gbjr0f6uvnnvqv19spql3slb6',
    userPoolId: cognitoOTUserPoolId,
    region: cognitoRegion,
  },
  isLyt: false,
}

export const PROD_CANARY_STAGE_CONFIG: StageConfiguration = {
  stageName: 'prodcanary', // from serverless.yml
  domain: 'app.opentradecanary.com',
  websocketUrl: 'wss://ws.opentradecanary.com',
  serverApiBaseUrl: 'https://api.opentradecanary.com',
  graphqlUrl: 'https://gql.opentradecanary.com',
  restAPIKey: PROD_CANARY_REST_API_KEY,
  supportedChains: prodAssetChains,
  chainConfigurations: [CHAIN_CONFIG_PROD_MAINNET, CHAIN_CONFIG_PROD_AVALANCHE, CHAIN_CONFIG_PROD_PLUME],
  userConnections: [],
  cognitoConfig: {
    clientId: '4dp7gp0ijg829lfldt849ifovr',
    userPoolId: cognitoCanaryUserPoolId,
    region: cognitoRegion,
  },
  isLyt: false,
}

export const PROD_CANARY_LYT_STAGE_CONFIG_FB: StageConfiguration = {
  stageName: 'prodsierracanary', // from serverless.yml
  domain: 'app.sierracanary.money',
  websocketUrl: '',
  serverApiBaseUrl: 'https://api.sierracanary.money',
  graphqlUrl: '',
  lytPoolAddr: '0x6E6080e15f8C0010d333D8CAeEaD29292ADb78f7',
  restAPIKey: 'VFxdnhb2Bl2iuYP9HHLLbH10sWsqbmF2v5OZoO27',
  supportedChains: [
    { name: 'Avalanche', chain: 'Avalanche', chainID: ChainId.AVALANCHE, rpcUrl: PROD_AVALANCHE_FRONTEND_URL },
  ],
  chainConfigurations: [CHAIN_CONFIG_LYT_PROD_FB],
  userConnections: [],
  cognitoConfig: {
    clientId: '4kvjhso0fs5l2a3dioqc04tpnu',
    userPoolId: 'us-east-1_X2V2o4RfK',
    region: cognitoRegion,
  },
  parentStageConfiguration: PROD_STAGE_CONFIG,
  parentChainConfiguration: CHAIN_CONFIG_PROD_AVALANCHE,
  isLyt: true,
  oftAdapter: '0xc472d3a47719DE5F9d808CA91d7B70BD2138bCAa',
  layerZeroEid: 30106, //AVALANCHE_V2_MAINNET
}

export const PROD_LYT_STAGE_CONFIG_FB: StageConfiguration = {
  stageName: 'prodsierra', // from serverless.yml
  domain: 'app.sierra.money',
  websocketUrl: '',
  serverApiBaseUrl: 'https://api.sierra.money',
  graphqlUrl: '',
  lytPoolAddr: '0x6E6080e15f8C0010d333D8CAeEaD29292ADb78f7',
  restAPIKey: 'JUDjHysfLKF1t2fucRBQ1zs74peYCbe1S8w98bs6',
  supportedChains: [
    { name: 'Avalanche', chain: 'Avalanche', chainID: ChainId.AVALANCHE, rpcUrl: PROD_AVALANCHE_FRONTEND_URL },
  ],
  chainConfigurations: [CHAIN_CONFIG_LYT_PROD_FB],
  userConnections: [],
  cognitoConfig: {
    clientId: '7i2ghrkvnfaspon58jjd278t62',
    userPoolId: 'us-east-1_X2V2o4RfK',
    region: cognitoRegion,
  },
  parentStageConfiguration: PROD_STAGE_CONFIG,
  parentChainConfiguration: CHAIN_CONFIG_PROD_AVALANCHE,
  isLyt: true,
  oftAdapter: '0xc472d3a47719DE5F9d808CA91d7B70BD2138bCAa',
  layerZeroEid: 30106, //AVALANCHE_V2_MAINNET
}
